<template>
	<el-container>
		<el-header>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="$router.back(-1)" :src='"/img/webimg/back.png"' alt=""> -->
			<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="$router.back(-1)" icon="el-icon-arrow-left" type="text"></el-button>
			<span class="header_h2">选择预约日期 </span>
		</el-header>
	<el-main>
		<!-- <el-header class="greenmenu">
			<span @click="$router.back(-1)" class="backstr">
				<返回</span> <span class="header_h2">预约日期
			</span>
		</el-header> -->
		<div style="font-size: small;text-align: left;margin-bottom: 10px;">
			<li><b>分院名称：</b>{{BranchEnt.branch_name}}</li>
			<li><b>分院地址：</b>{{BranchEnt.branch_address}}</li>
			<li><b>联系电话：</b>{{BranchEnt.branch_tel}}</li>
		</div>
		<!-- <span class="header_h2" style="text-align: left;">已选分院：{{BranchEnt.branch_name}}
		</span> -->
		<!-- <ul style="font-size: small;text-align: left;">
			<li><b>分院：</b><span clsss="spantext"></span>
			</li>
			<li><b>地址：</b><span clsss="spantext">{{BranchEnt.branch_address}}</span>
			</li>
			<li> -->
				<!-- <el-button size="mini" type="primary" round @click="changebookrec()">刷新预约资源</el-button> -->
				<!-- <el-radio-group v-model="dateflag" @change="changebookrec()">
					<el-radio-button :label="0">最近3天</el-radio-button>
					<el-radio-button :label="1">最近7天</el-radio-button>
					<el-radio-button :label="2">最近15天</el-radio-button>
					<el-radio-button :label="3">一个月内</el-radio-button>
				</el-radio-group> -->
			<!-- </li>
		</ul> -->
		<el-row>
			<el-col :span="14">
				<el-select size="mini" @change="changeShowData" v-model="curbooktypeid" placeholder="请选择预约类别">
					<el-option v-for="item in BookTypeData" :label="item.type_name+'【'+item.timestep+'】'" :value="item.book_type_id">
						{{ item.type_name+'【'+item.timestep+'】' }}
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="10">
				<el-select size="mini" @change="changebookrec" v-model="dateflag" placeholder="请选择预约日期">
					<el-option label="最近3天" value='0'>最近3天</el-option>
					<el-option label="最近7天" value='1'>最近7天</el-option>
					<el-option label="最近15天" value='2'>最近15天</el-option>
					<el-option label="一个月内" value='3'>一个月内</el-option>
				</el-select>
			</el-col>
			<!-- <el-col :span="8">
				<el-select size="mini" @change="changeShowData" v-model="curtimestep" placeholder="请选择时间段">
					<el-option v-for="item in emBookTimeStep" :label="item.key" :value="item.key">{{ item.key }}</el-option>
				</el-select>
			</el-col> -->
		</el-row>
		<el-row>
			<el-col :span="8" v-for="(item,$index) in showdateList">
				<div>
					<el-badge type="success" :value="item.capacity-item.booked" style="margin-top: 10px;margin-right: 10px;">
						<!-- <el-button size="small">{{item.book_date}}</el-button> -->
						<el-button size="mini" type="primary" circle @click="btnBook($index,item)">{{ShowDateStr(item.book_date)}}</el-button>
					</el-badge>
				</div>
			</el-col>
		</el-row>
		<!-- <div class="branch">
			<div v-for="(item,$index) in GetShowData">
				<ul style="float: left;width: 180px; margin: auto;">
					<p><span class="spanlabel">{{item.book_date}}</span></p>
					<p><span class="spantxt">{{item.timestep}}</span></p>
					<p v-if="item.booked==null||item.capacity>item.booked">
						<span class="spanlabel">{{item.type_name}}</span>【剩余{{item.capacity-item.booked}}】
					</p>
				</ul>
				<p>
					<el-button size="mini" type="primary" round @click="btnBook($index,item)">预约</el-button>
				</p>
			</div>
		</div> -->


	</el-main>
</el-container>
</template>

<script>
	import book from '../../apifunction/Book.js'
	import ordercus from '../../apifunction/OrderCus.js'
	import ordergroupitem from '../../apifunction/OrderGroup.js'
	export default {
		data() {
			return {
				BranchEnt: null,
				dateList: [],
				showdateList:[],
				dateflag: '0',
				curcus: '',
				BookTypeData: [],
				curbooktypeid: '',
				emBookTimeStep: this.$enums.BookTimeStep,
				curtimestep: this.$enums.BookTimeStep[0].key
			};
		},
		created() {
			// this.BranchEnt =JSON.parse(this.$route.query.ent) ;
			// this.curcus = JSON.parse(this.$route.query.curcus);
			this.initData();
		},
		watch: {
			// 如果路由发生变化，再次执行该方法
			"$route": "initData"
		},
		methods: {
			InitBranchBookType() {
				book.GetBranchBookType(this.BranchEnt.branch_id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								return;
							this.BookTypeData = JSON.parse(ent.Data);
							this.curbooktypeid = this.BookTypeData[0].book_type_id;
						} else
							this.$message.info(ent.Msg);
					})
			},
			/*日期处理*/
			dateFormat: function(row) {
				var d = row.book_date
				return this.$moment(d).format("YYYY-MM-DD")
			},
			initData() {

				this.BranchEnt = JSON.parse(this.$route.query.ent);
				this.curcus = JSON.parse(this.$route.query.entcus);
				this.InitBranchBookType();
				this.changebookrec()

			},
			ShowDateStr(date){
				var dd = new Date(date);
				// alert(dd)
				var strDate = dd.getDate();
				var strweek= this.CommonFun.getWeekDay(dd);
				return strDate+'号'+strweek
			},
			changeShowData(){
				this.showdateList=this.GetShowData();
			},
			GetShowData() {
				if (this.dateList.length < 1)
					return [];

				return this.dateList.filter((f, index) => {
					let b = true;
					if (this.curbooktypeid != f.book_type_id)
						b = false;
					// if (this.curtimestep != '' && f.timestep != this.curtimestep) {
					// 	b = false;
					// }
					if (b)
						return f;
				})
			},
			changebookrec() {
				if (this.dateflag == '0') {
					this.GetDateList(2)
				}
				if (this.dateflag == '1') {
					this.GetDateList(6)
				}
				if (this.dateflag == '2') {
					this.GetDateList(14)
				}
				if (this.dateflag == '3') {
					this.GetDateList(30)
				}
			},
			GetDateList(days) {
				var dstart =this.CommonFun.GetDateByAddDay(this.CommonFun.GetNowDate(), 1);
				var dend = this.CommonFun.GetDateByAddDay(dstart, days);
				book.GetBranchBookCapacityUsed(this.BranchEnt.branch_id, dstart, dend)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.dateList = JSON.parse(ent.Data);
								for (let i = 0; i < this.dateList.length; i++) {
									this.dateList[i].book_date = this.dateFormat(this.dateList[i])
								}
								this.showdateList=this.GetShowData();
							} else
								this.showdateList = []
						} else
							this.$message.info(ent.Msg);
					})
			},
			btnBook(index, row) {
				var p = {
					book_type_id: row.book_type_id,
					branch_id: this.BranchEnt.branch_id,
					startbookdate: row.book_date,
					endbookdate: row.book_date,
					bookstatus: '1',
					mobile: '',
					idcard: '',
					member_id: this.curcus.id,
					bookcode: '' //this.BookCode
				}
				book.GetBookDetailByJson(p)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								let s = '您已约过' + this.dateFormat(row.book_date) + '号' + row.timestep + '【' + row.type_name + '】体检了！';
								this.$message.info(s);
							} else {
								this.$confirm('确定要预约【'+row.book_date+'】【'+this.BranchEnt.branch_name+'】的体检吗?', '提示', {
								          confirmButtonText: '确定',
								          cancelButtonText: '取消',
								          type: 'warning'
								        }).then(() => {
								          var info = {
								          	book_id: this.CommonFun.NewGuid(),
								          	book_type_id: row.book_type_id,
								          	book_type_name: row.type_name,
								          	member_id: this.curcus.id,
								          	member_name: this.curcus.cusname,
								          	bookstatus: '1',
								          	branch_id: this.BranchEnt.branch_id,
								          	bookdate: row.book_date,
								          	mobile: this.curcus.mobile,
								          	idcard: this.curcus.idcard,
								          	bookcode: ''
								          }
								          book.AddBookDetail(info)
								          	.then(res => {
								          		let ent = JSON.parse(JSON.stringify(res.data))
								          		if (ent.Flag == 'success') {
								          			// this.$message.info('预约成功！');
								          			this.changebookrec();
								          			ordercus.UpdateCusStatus(this.curcus.id, '30');
								          			this.tobooksuccess();
								          		} else
								          			this.$message.info('预约失败！');
								          	})
								        });
								
							}
						} else
							this.$message.info(ent.Msg);
					})

			},
			tobooksuccess(){
				var data = {
					path: '/BookSuccess',
					query: {
						mobile: this.curcus.mobile
					}
				}
				this.$router.push(data)
			}
		}
	}
</script>

<style>

</style>
